import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import img1 from "../assests/clientle/innov.png";
import img2 from "../assests/clientle/otsi.png";
import img3 from "../assests/clientle/orianapower.png";
import img4 from "../assests/clientle/movingpixels.png";
import img5 from "../assests/clientle/univastu.png";
import img6 from "../assests/clientle/bootes.png";
import img7 from "../assests/clientle/stenovate.png";
import img8 from "../assests/clientle/susten.png";
import img9 from "../assests/clientle/crest.png";
import img10 from "../assests/clientle/iffco.png";
import img11 from "../assests/clientle/cofynd.png";
import img12 from "../assests/clientle/irep.png";
import img13 from "../assests/clientle/bookmyflex.png";
import img14 from "../assests/clientle/elektroniklab.png";
import img15 from "../assests/clientle/propertypistol.png";
import img16 from "../assests/clientle/cstechai.png";
import img17 from "../assests/clientle/workie.png";
import img18 from "../assests/clientle/hdfccredila.png";
import img19 from "../assests/clientle/arche.png";
import img20 from "../assests/clientle/authum.png";
import img21 from "../assests/clientle/tatapower.png";
import img22 from "../assests/clientle/girnarsoft.png";
import img23 from "../assests/clientle/aarnaventures.png";
import img24 from "../assests/clientle/aeroaeon.png";
import img25 from "../assests/clientle/amazon-seller-central.png";
import img26 from "../assests/clientle/amazon-service.png";
import img27 from "../assests/clientle/aramex.png";
import img28 from "../assests/clientle/arohan.png";
import img29 from "../assests/clientle/bidguru.png";
import img30 from "../assests/clientle/brightpath-logo.png";
import img31 from "../assests/clientle/byju's-logo.png";
import img32 from "../assests/clientle/cardekho.png";
import img33 from "../assests/clientle/cowrks.png";
import img34 from "../assests/clientle/damson.png";
import img35 from "../assests/clientle/eduvision.png";
import img36 from "../assests/clientle/flipkart-seller-hub.png";
import img37 from "../assests/clientle/go-auto.png";
import img38 from "../assests/clientle/godigit.png";
import img39 from "../assests/clientle/hitachi-energy.png";
import img40 from "../assests/clientle/ikya.png";
import img41 from "../assests/clientle/indospirit.png";
import img42 from "../assests/clientle/livspace.png";
import img43 from "../assests/clientle/netcon.png";
import img44 from "../assests/clientle/phonepe.png";
import img45 from "../assests/clientle/piramal-foundation.png";
import img46 from "../assests/clientle/piramal-swasthya.png";
import img47 from "../assests/clientle/qdesq.png";
import img48 from "../assests/clientle/quess.png";
import img49 from "../assests/clientle/quickheal.png";
import img50 from "../assests/clientle/reliance-home-finance.png";
import img51 from "../assests/clientle/runh-power.png";
import img52 from "../assests/clientle/sbicard.png";
import img53 from "../assests/clientle/skweldedmesh.png";
import img54 from "../assests/clientle/small-box-garden.png";
import img55 from "../assests/clientle/stl.png";
import img56 from "../assests/clientle/uber.png";
import img57 from "../assests/clientle/uncube.png";
import img58 from "../assests/clientle/urban-company.png";
import img59 from "../assests/clientle/vi.png";
import img60 from "../assests/clientle/wtm.png";
import img61 from "../assests/clientle/zomato.png";
import img62 from "../assests/clientle/zte.png";

const allimg = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  img31,
  img32,
  img33,
  img34,
  img35,
  img36,
  img37,
  img38,
  img39,
  img40,
  img41,
  img42,
  img43,
  img44,
  img45,
  img46,
  img47,
  img48,
  img49,
  img50,
  img51,
  img52,
  img53,
  img54,
  img55,
  img56,
  img57,
  img58,
  img59,
  img60,
  img61,
  img62,
];

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 6,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const OurClient = () => {
  return (
    <>
      <section id="clients" className="u-py-60 dino-seo-clients" style={{ backgroundColor: "#ECF5FE" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="h1">Our Clients</h2>
              <div className="u-h-4 u-w-50 bg-primary rounded mt-4 u-mb-50 mx-auto"></div>
            </div>
          </div>
          <Carousel
            swipeable={true}
            draggable={true}
            showDots={"mobile" ? false : true}
            responsive={responsive}
            // ssr={true} // means to render carousel on server-side.
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={2000}
            // keyBoardControl={true}
            customTransition="linear 0.8s"
            // transitionDuration={1000}
            containerclassName="carousel-container"
            removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
            // deviceType={this.props.deviceType}
            dotListclassName="custom-dot-list-style"
            itemclassName="carousel-item-padding-90-px"
          >
            {allimg.map((e) => (
              <div className="card m-3">
                <img
                  className="lazyloadimg2 img-fluid"
                  src={e}
                  data-original={e}
                  alt="Premisin"
                />
              </div>
            ))}
          </Carousel>
        </div>
      </section>
    </>
  );
};

export default OurClient;
